import { SxProps } from '@mui/system';
import { atom, RecoilState } from 'recoil';

import { DialogTypes } from 'types/types';

type ConfirmationDialog = {
  dialogType?: DialogTypes;
  isOpen?: boolean;
  action?: () => void;
};

type DialogState = {
  isOpen?: boolean;
  dialogType?: DialogTypes;
  data?: any;
  sx?: SxProps;
};

export const dialogState: RecoilState<DialogState> = atom<DialogState>({
  key: 'dialogState',
  default: {
    isOpen: false,
    dialogType: undefined,
    data: undefined,
    sx: {},
  },
});

export const confirmDialogState: RecoilState<ConfirmationDialog> =
  atom<ConfirmationDialog>({
    key: 'confirmDialogState',
    default: {
      isOpen: false,
      dialogType: undefined,
      action: () => {},
    },
  });
